import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { IndentMaterialEntity } from "./indent-form-entity";
@Entity('indent_item_preparation')
export class IndentItemEntity {
    @PrimaryGeneratedColumn("increment",
    {name:'indent_item_id'})
    indentItemId:number;

    @Column('int', {
        name: "indent_material_preparation_id"
      })
      indentMaterialPreparationId: number;

      @Column('int', {
        name: "item_sub_category_id"
      })
      itemsubcategoryId: number;

      @Column('int', {
        name: "item_id"
      })
      itemId: number;

      @Column('int', {
        name: "quantity"
      })
      quantity: number;

      @Column('int', {
        nullable: false,
        name: "received_quantity",
        default:0
      })
      receivedQuantity: number;

      @Column('int', {
        nullable: false,
        name: 'unit_id',
        default: 0
    })
    unitId: number;
    
    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
      nullable: false,
      default: true,
       name: "is_active"
      })
      isActive: boolean;

    @ManyToOne(type =>IndentMaterialEntity,indentMaterial =>indentMaterial.indentItemDetails, {nullable:false})
    @JoinColumn({name:'indent_material_preparation_id'})
    indentMaterialEntityInfo:IndentMaterialEntity

      
}